import { PRIVILEGED_EDITOR_ACCESS_ROLES } from '../constants/roleConstants';

const EditorCreateTask = () => import('../components/Editor/AddTask');
const EditorCopyFrom = () => import('../components/Editor/CopyFrom');
const EditorCopyFromV2 = () => import('../components/Editor/CopyFromV2');
const EditorCreate = () => import('../components/Editor/Create');
const EditorInstructionPackageDetail = () =>
  import('../components/Editor/InstructionPackageDetail');
const EditorInstructionPackagesList = () =>
  import('../components/Editor/InstructionPackagesList');
const EditorList = () => import('../components/Editor/List');
const EditorProductTemplatesList = () =>
  import('../components/Editor/ProductTemplatesList');
const EditorStandardWorkInstructionView = () =>
  import('../components/Editor/StandardWorkInstructionView');
const EditorStandardTasksList = () =>
  import('../components/Editor/StandardTasksList');
const EditorTasks = () => import('../components/Editor/Tasks');
const EditorWorkInstructionsList = () =>
  import('../components/Editor/WorkInstructionsList');
const EditorTaskView = () => import('../modules/Editor/views/TaskView');
const EditorWorkInstructions = () =>
  import('../components/Editor/WorkInstructions');

const editorRoutes = [
  {
    path: '/view/editor',
    name: 'editor-list',
    component: EditorList,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/work-instructions',
    name: 'editor-work-instructions-list',
    component: EditorWorkInstructionsList,
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/work-instructions/:packageId',
    name: 'editor-work-instructions-package',
    component: EditorStandardWorkInstructionView,
    props: {
      showStatusBadge: false,
    },
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/instruction-packages',
    name: 'editor-instruction-packages-list',
    component: EditorInstructionPackagesList,
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/instruction-packages/:packageId',
    name: 'editor-instruction-packages-detail',
    component: EditorInstructionPackageDetail,
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/standard-tasks',
    name: 'editor-standard-tasks-list',
    component: EditorStandardTasksList,
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/standard-tasks/:id',
    name: 'editor-standard-task-diagram',
    component: EditorTaskView,
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/standard-tasks/:id/instruction',
    name: 'editor-standard-task-instruction',
    component: EditorTaskView,
    meta: {
      authRequired: true,
      requiredRoles: PRIVILEGED_EDITOR_ACCESS_ROLES,
    },
  },
  {
    path: '/view/editor/create',
    name: 'editor-create',
    component: EditorCreate,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates',
    name: 'editor-product-templates-list',
    component: EditorProductTemplatesList,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates/create',
    name: 'editor-product-templates-create',
    component: EditorCreate,
    props: {
      jobType: 'productLibrary_standard_draft',
      listRouteName: 'editor-product-templates-list',
      taskRouteName: 'editor-product-templates-tasks',
    },
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates/:id/edit',
    name: 'editor-product-templates-edit',
    component: EditorCreate,
    props: {
      jobType: 'productLibrary_standard_draft',
      listRouteName: 'editor-product-templates-list',
      taskRouteName: 'editor-product-templates-tasks',
    },
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates/:id/create',
    name: 'editor-product-templates-create-task',
    component: EditorCreateTask,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates/:id/copyfrom',
    name: 'editor-product-templates-copyfrom',
    component: EditorCopyFrom,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates/:id/copyfrom-v2',
    name: 'editor-product-templates-copyfrom-v2',
    component: EditorCopyFromV2,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/product-templates/:id/:taskNumber',
    name: 'editor-product-templates-template',
    component: EditorTaskView,
    meta: { authRequired: true, needsTaskLock: true },
  },
  {
    path: '/view/editor/product-templates/:id',
    name: 'editor-product-templates-tasks',
    component: EditorTasks,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id',
    name: 'editor-tasks',
    component: EditorTasks,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id/wi',
    name: 'editor-work-instructions',
    component: EditorWorkInstructions,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id/edit',
    name: 'editor-edit-job',
    component: EditorCreate,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id/create',
    name: 'editor-create-task',
    component: EditorCreateTask,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id/copyfrom',
    name: 'editor-copyfrom',
    component: EditorCopyFrom,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id/copyfrom-v2',
    name: 'editor-copyfrom-v2',
    component: EditorCopyFromV2,
    meta: { authRequired: true },
  },
  {
    path: '/view/editor/:id/:taskNumber',
    name: 'editor-template',
    component: EditorTaskView,
    meta: { authRequired: true, needsTaskLock: true },
  },
];

export default editorRoutes;
